<template>
  <card-seplag titulo="Acompanhar Declarações">
    <div class="p-col-12 validarArquivo-container">
      <div class="validarArquivo-container-cabecalho">
        <div>
          <span class="label-info">Órgão: </span>
          <span>{{ userOrgao }}</span>
        </div>

        <div>
          <span class="label-info">Usuário: </span>
          <span>{{ userName }}</span>
        </div>
      </div>

      <div class="validarArquivo-container-filtro">
        <Rotulo nome="Exercício" cols="12 1">
          <Dropdown
            class="classe-dropdown"
            v-model="filtro.idenExercicio"
            :options="dropdownExercicio"
            optionLabel="ano"
            optionValue="idenExercicio"
            @keyup.enter="search"
            @change="listarOrgao"
          />
        </Rotulo>

        <Rotulo nome="Órgão" cols="12 2">
          <Dropdown
            class="classe-dropdown"
            v-model="filtro.orgaoEmpresaUsuario[0]"
            :options="dropdownOrgao"
            optionLabel="descricao"
            optionValue="idenOrgao"
            :filter="true"
            filterPlaceholder="Pesquisa..."
            @keyup.enter="search"
          />
        </Rotulo>

        <Rotulo nome="Pesquisa por Nome" cols="12 2">
          <InputText
            class="classe-input"
            type="text"
            v-model="filtro.nome"
            @keyup.enter="search"
          />
        </Rotulo>

        <Rotulo nome="CPF" cols="12 1">
          <InputMask
            class="classe-input"
            mask="999.999.999-99"
            v-model="filtro.cpf"
            @keyup.enter="search"
          />
        </Rotulo>

        <Rotulo nome="Tipo de Declaração" cols="12 2">
          <Dropdown
            class="classe-dropdown"
            v-model="filtro.tipoDeclaracao"
            :options="dropdowntiposDeclaracoes"
            optionLabel="name"
            optionValue="code"
            @keyup.enter="search"
          />
        </Rotulo>

        <Rotulo nome="Situação da Declaração" cols="12 2">
          <Dropdown
            class="classe-dropdown"
            v-model="filtro.situacao"
            :options="dropdownSituacao"
            optionLabel="name"
            optionValue="code"
            @keyup.enter="search"
          />
        </Rotulo>
        <Button
          icon="pi pi-search"
          @click="search"
          label="buscar"
          class="classe-buttom"
        />
      </div>
    </div>

    <DataTable
      :value.sync="dados"
      class="p-datatable-responsive-demo p-datatable-gridlines"
      :paginator="true"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="{first} de {last} - {totalRecords} registros"
      :totalRecords.sync="totalRegistro"
      responsiveLayout="scroll"
      :rows="10"
      :lazy="true"
      @page="
        onSearchPaginacao($event.originalEvent.rows, $event.originalEvent.page)
      "
    >
      <template #header v-if="dados.length > 0">
        <div style="display: flex">
          <Button
            @click="exportExcel"
            label="Excel"
            icon="pi pi-external-link"
            class="p-button-raised"
            style="
              margin: 5px;
              background: #107c41;
              border-color: rgb(1 114 52);
              width: 10rem;
            "
          />
          <Button
            @click="exportPDF"
            label="PDF"
            icon="pi pi-external-link"
            class="p-button-raised"
            style="
              margin: 5px;
              background: #c5031d;
              border-color: #b70019;
              width: 10rem;
            "
          />
        </div>
      </template>
      <Column
        field="numrMatricula"
        header="Matrícula"
        headerStyle="width: 1rem"
        bodyClass="columnAlign"
      />
      <Column
        field="nomePessoa"
        header="Nome"
        headerStyle="width: 5rem"
        bodyClass="columnAlign"
      />
      <Column
        field="cpfFormatado"
        header="CPF"
        headerStyle="width: 2rem"
        bodyClass="columnAlign"
      />
      <Column
        field="setor"
        header="Setor"
        headerStyle="width: 5rem"
        bodyClass="columnAlign"
      />
      <Column
        field="tipoDeclaracaoDescricao"
        header="Tipo de Declaração"
        headerStyle="width: 2rem"
        bodyClass="columnAlign"
      />
      <Column
        field="statDeclaracaoDescricao"
        header="Situação da Declaração"
        headerStyle="width: 2rem"
        bodyClass="columnAlign"
      />
      <Column
        field="numrProtocolo"
        header="Protocolo"
        headerStyle="width: 3rem"
        bodyClass="columnAlign"
      />
      <Column
        field="ultimaNotificacaoEmail"
        header="Última Notificação E-mail"
        headerStyle="width: 3rem"
        bodyClass="columnAlign"
      />
      <template #empty>
        <div style="text-align: center; margin: 1rem">
          <span
            style="font-family: sans-serif; font-size: 1.2rem; font-weight: 500"
          >
            Nenhum registro encontrado
          </span>
        </div>
      </template>
    </DataTable>

    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
  </card-seplag>
</template>

<script >
import CardSeplag from "@/template/CardSeplag.vue";
import { baseApiUrl } from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
import download from "downloadjs";
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "AcompanharDeclaracao",
  components: { CardSeplag, Rotulo, CardExibirPDF },

  data: function () {
    return {
      selectedOrgao: null,
      dropdownExercicio: null,
      dropdownOrgao: null,
      anoAtual: new Date().getFullYear(),
      userName: "",
      userOrgao: "",
      formTitulo: "",
      idenArquivoDeclaracaoBem: 0,
      isVisibleForm: false,
      dropdowntiposDeclaracoes: [
        { name: "Formulário", code: "FORMULARIO" },
        { name: "Arquivo", code: "ARQUIVO" },
        { name: "Todos", code: "todos" },
      ],
      dropdownSituacao: [
        { name: "Finalizada", code: "FINALIZADA" },
        { name: "Finalizada Alterada", code: "FINALIZADA_ALTERADA" },
        { name: "Todas Finalizadas", code: "TODAS_FINALIZADAS" },
        { name: "Não Realizada", code: "NAO_REALIZADA" },
        { name: "Todos", code: "todos" },
      ],
      dados: [],
      filtro: {
        nome: null,
        cpf: null,
        matriculaUsuario: null,
        situacao: null,
        tipoDeclaracao: null,
        idenPessoaUsuario: null,
        idenExercicio: null,
        orgaoEmpresaUsuario: [],
      },
      filtroTodos: {
        idenOrgao: 0,
        descOrgao: "TODOS",
        descricao: "0 - TODOS",
      },
      sizePage: 10,
      isExibirPDF: false,
      tituloPDF: " ",
      dadosRelatorioBase64: "",
      totalRegistro: 0,
    };
  },
  methods: {
    carregarDados() {
      this.filtro.matriculaUsuario =
        this.$store.getters.getUser.contaAcesso.pessoa.servidor == null
          ? this.$store.getters.getUser.contaAcesso.pessoa.numrCpf
          : this.$store.getters.getUser.contaAcesso.pessoa.servidor
              .numrMatricula;
      this.filtro.idenPessoaUsuario =
        this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa;
      this.userName = this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa;
      this.userOrgao =
        this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao;

      this.listarExercicios();
    },

    listarOrgao() {
      this.$http
        .get(
          `${baseApiUrl}/pessoaexercicios/orgaosperfil/${this.filtro.idenExercicio}`
        )
        .then((res) => {
          if (res.data.length > 1) {
            this.dropdownOrgao = [this.filtroTodos, ...res.data];
          } else {
            this.dropdownOrgao = res.data;
          }
        });
    },

    listarExercicios() {
      this.$http
        .get(`${baseApiUrl}/exercicios/periodo/2021/${this.anoAtual}`)
        .then((res) => {
          this.dropdownExercicio = res.data;
          this.filtro.idenExercicio = res.data[0].idenExercicio;
          this.listarOrgao();
        });
    },

    pesquisarDeclaracoes() {
      //Trata o filtro "Todos", muda o valor "0" para vazio
      let requestBody = { ...this.filtro };
      if (this.filtro.orgaoEmpresaUsuario == 0) {
        requestBody.orgaoEmpresaUsuario = null;
      }
      this.$http
        .post(
          `${baseApiUrl}/acompanhamentos/rh?size=${this.sizePage}&page=0&sort=nomePessoa,asc`,
          JSON.stringify(requestBody)
        )

        .then((res) => {
          this.dados = res.data.content;
          this.totalRegistro = res.data.totalElements;
          this.reorganizarDados();
        });
    },

    verificaVazio() {
      Object.keys(this.filtro).forEach((item) => {
        this.filtro[item] =
          this.filtro[item] === ""
            ? null
            : this.filtro[item] == "todos"
            ? null
            : this.filtro[item];
      });
    },

    search() {
      this.verificaVazio();
      this.pesquisarDeclaracoes();
    },

    onSearchPaginacao(rows, page) {
      this.$http
        .post(
          `${baseApiUrl}/acompanhamentos/rh?size=${rows}&page=${page}&sort=nomePessoa,asc`,
          JSON.stringify(this.filtro)
        )
        .then((res) => {
          this.dados = res.data.content;
          this.totalRegistro = res.data.totalElements;
          this.reorganizarDados();
          this.sizePage = rows;
        });
    },

    reorganizarDados() {
      this.dados = this.dados.map((item) => {
        let valueReturn = {
          idenPessoaExercicio: item.idenPessoaExercicio,
          tipoDeclaracao: item.tipoDeclaracao,
          statDeclaracao: item.statDeclaracao,
          nomePessoa: item.nomePessoa,
          cpfFormatado: item.cpfFormatado,
          numrMatricula: item.numrMatricula,
          statDeclaracaoDescricao: item.statDeclaracaoDescricao,
          tipoDeclaracaoDescricao: item.tipoDeclaracaoDescricao,
          lastNotificationEmail: item.ultimaNotificacaoEmail,
          numrProtocolo: item.numrProtocolo,
          setor: item.vinculo.siglaUnidade,
          //arquivosDeclaracao:item.arquivosDeclaracao
        };

        return valueReturn;
      });
    },
    atualizar() {
      this.search();
    },
    exportExcel() {
      let listaOrgao = [];

      if (this.filtro.orgaoEmpresaUsuario[0] != 0) {
        listaOrgao = this.filtro.orgaoEmpresaUsuario.map((item) => {
          return {
            idenOrgao: item,
          };
        });
      } else {
        listaOrgao = this.dropdownOrgao;
      }

      let jsonPost = {
        idenExercicio: this.filtro.idenExercicio,
        tipoRelatorio: "E",
        orgaoLotacao:
          this.$store.getters.getUser.contaAcesso.pessoa
            .listaServidorOrgaoSetor[0].descOrgao,
        usuarioLogado:
          this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
        // nome:this.filtro.nome != "" ? this.filtro.nome : null,
        nome: this.filtro.nome == "" ? null : this.filtro.nome,
        cpf: this.filtro.cpf != "" ? this.filtro.cpf : null,
        listaOrgao,
        tipoDeclaracao:
          this.filtro.tipoDeclaracao == "" ||
          this.filtro.tipoDeclaracao == "todos"
            ? null
            : this.filtro.tipoDeclaracao,
        statDeclaracao:
          this.filtro.situacao == "" || this.filtro.situacao == "todos"
            ? null
            : this.filtro.situacao,
      };

      this.$http
        .post(
          `${baseApiUrl}/acompanhamentos/relatorio/vinculo`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          download(
            `data:application/excel;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/excel"
          );
        });
    },
    exportPDF() {
      let listaOrgao = [];

      if (this.filtro.orgaoEmpresaUsuario[0] != 0) {
        listaOrgao = this.filtro.orgaoEmpresaUsuario.map((item) => {
          return {
            idenOrgao: item,
          };
        });
      } else {
        listaOrgao = this.dropdownOrgao.filter((item) => item.idenOrgao != 0);
      }

      let jsonPost = {
        idenExercicio: this.filtro.idenExercicio,
        tipoRelatorio: "P",
        orgaoLotacao:
          this.$store.getters.getUser.contaAcesso.pessoa
            .listaServidorOrgaoSetor[0].descOrgao,
        usuarioLogado:
          this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
        //nome:this.filtro.nome != "" ? this.filtro.nome : null,
        nome: this.filtro.nome == "" ? null : this.filtro.nome,
        cpf: this.filtro.cpf != "" ? this.filtro.cpf : null,
        listaOrgao,
        tipoDeclaracao:
          this.filtro.tipoDeclaracao == "" ||
          this.filtro.tipoDeclaracao == "todos"
            ? null
            : this.filtro.tipoDeclaracao,
        statDeclaracao:
          this.filtro.situacao == "" || this.filtro.situacao == "todos"
            ? null
            : this.filtro.situacao,
      };

      this.$http
        .post(
          `${baseApiUrl}/acompanhamentos/relatorio/vinculo`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          this.dadosRelatorioBase64 = `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`;
          this.isExibirPDF = true;
        });
    },
    retificarDeclaracao(declaracao) {
      this.$router.push({
        name: "retificacaoDeclaracao",
        params: { id: declaracao.idenPessoaExercicio },
      });
    },
  },
  mounted() {
    this.carregarDados();
  },
  /*watch:{
      'filtro.nome'(newValue){
        
        if(newValue.length > 150){
          this.filtro.nome = newValue.substring(0,150)
        }
      }
    }*/
};
</script>

<style scoped>
.classe-dropdown {
  margin-right: 0.5rem;
}

.classe-input {
  max-width: 20rem;
  margin-right: 0.5rem;
  /* margin: auto 0.5rem; */
}

.label-info {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 0.4rem;
}

.validarArquivo-container-cabecalho {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.validarArquivo-container-cabecalho > div {
  margin-bottom: 0.9rem;
}

.validarArquivo-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.button-acoes > button {
  margin: 0.3rem auto;
}

.validarArquivo-container-filtro {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.classe-buttom {
  max-width: 10rem;
  max-height: 40px;
  margin-top: 14px;
}

@media screen and (max-width: 425px) {
  .classe-input {
    margin-bottom: 0.5rem;
    /* margin: auto 0.5rem; */
  }

  .validarArquivo-container-filtro {
    display: flex;
    flex-direction: column;
  }

  .classe-dropdown {
    margin-bottom: 0.5rem;
  }

  .classe-buttom {
    max-width: 100%;
  }
}
</style>

<style>
.column-acoes {
  width: 20rem;
}

.button-icon {
  font-size: 1.5rem;
}

@media screen and (min-width: 481px) and (max-width: 1080px) {
  .column-acoes {
    width: 5rem;
  }

  .button-acoes > button > span {
    display: none;
  }
  .button-acoes > button {
    padding: 0.5rem 0.69rem;
  }
  .button-icon {
    font-size: 1.5rem;
  }
}
</style>